module.exports = "/images/sprite.svg?50ab9cc332c3f3e4d04f75f6afa0025c";